<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
  import Chart from './chart.vue'
  export default {
    data() {
      return {
        cdata:{},
        name:'dau'
      };
    },
    components: {
      Chart,
    },
    mounted() {
    },
    methods: {
      // 根据自己的业务情况修改
     
    }
  };
</script>

<style lang="scss" scoped>
</style>